const scrollTo = () => {
    const btn = document.querySelector('[data-scroll-top]');

    if (btn) {

        window.addEventListener('scroll', () => {
            if (window.scrollY > 400) {
                btn.classList.add('is-active');
            } else {
                btn.classList.remove('is-active');
            }
        });

        btn.addEventListener('click', () => {
            window.scrollTo({
                top: 0,
                behavior: 'smooth',
            });
        });
    }


    const isHomePage = location.pathname === '/' || location.pathname.endsWith('/index.html');
    document.querySelectorAll('[data-scrollto]').forEach(button => {
        button.addEventListener('click', e => {

            if(isHomePage) {
                e.preventDefault();
                document.querySelector('[data-main-menu="menu"]').classList.remove('is-open');
                document.querySelectorAll('[data-main-menu="trigger"]').forEach(item => {
                    item.classList.remove('is-open');
                });
                document.querySelector('.header').classList.remove('is-open');
                document.querySelector('body').classList.remove('is-hidden');

                const targetId = button.getAttribute('data-scrollto');
                console.log(targetId)
                const target = document.querySelector(targetId);
                console.log(target)

                if (target) {
                    target.scrollIntoView({
                        top: 0 ,
                        behavior: 'smooth',
                    });
                }
            }
        });
    });
};

export default scrollTo;
